{
  "tabs": {
    "chat": "Chat",
    "reminders": "Påmindelser",
    "calendar": "Kalender",
    "settings": "Indstillinger"
  },
  "common": {
    "cancel": "Annuller",
    "save": "Gem",
    "confirm": "Bekræft",
    "delete": "Slet",
    "back": "Tilbage",
    "close": "Luk",
    "edit": "Rediger",
    "search": "Søg",
    "all": "Alle",
    "loading": "Indlæser...",
    "error": "Noget gik galt",
    "notFound": "Ikke fundet",
    "tryAgain": "Prøv igen",
    "retry": "Prøv igen",
    "undo": "Fortryd",
    "pullToRefresh": "Træk for at opdatere",
    "justNow": "lige nu"
  },
  "auth": {
    "welcome": "Velkommen til FishMemory",
    "tagline": "Din WhatsApp-påmindelsesassistent, nu i lommen.",
    "subtitle": "Din WhatsApp-påmindelsesassistent, nu i lommen.",
    "phoneLabel": "Dit WhatsApp-nummer",
    "phoneHint": "Vi sender en bekræftelseskode via WhatsApp",
    "invalidPhone": "Indtast et gyldigt telefonnummer",
    "continue": "Fortsæt",
    "enterPhone": "Indtast dit WhatsApp-nummer",
    "phonePlaceholder": "Telefonnummer",
    "sendCode": "Send kode",
    "verifyTitle": "Bekræft dit nummer",
    "otpSentTo": "En 6-cifret kode er sendt til {{phone}} via WhatsApp",
    "enterFullCode": "Indtast alle 6 cifre",
    "invalidOtp": "Ugyldig kode. Prøv igen.",
    "otpFailed": "Kunne ikke sende kode. Prøv igen.",
    "otpResent": "Kode sendt igen",
    "resendIn": "Send igen om {{seconds}}s",
    "resendCode": "Send kode igen",
    "enterOtp": "Indtast koden sendt til din WhatsApp",
    "verify": "Bekræft",
    "resend": "Send kode igen",
    "wrongNumber": "Forkert nummer?",
    "backToPhone": "Tilbage til nummer",
    "editPhone": "Rediger telefonnummer",
    "error": "Fejl",
    "setupTitle": "Lad os sætte det op",
    "setupSubtitle": "Du kan altid ændre det senere i Indstillinger",
    "namePlaceholder": "Dit navn",
    "letsGo": "Afslut opsætning",
    "skipForNow": "Spring over for nu"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Skriv en besked...",
    "inputPlaceholder": "Skriv en besked...",
    "typing": "FishMemory skriver...",
    "online": "Online",
    "connecting": "Forbinder...",
    "reconnecting": "Genforbinder...",
    "offline": "Offline",
    "empty": "Start en samtale",
    "emptyHint": "Opret påmindelser, tjek din kalender eller få hjælp.",
    "emptyAction": "Send en prøve-påmindelse",
    "actions": "Chat handlinger",
    "keep": "Behold beskeder",
    "clearTitle": "Ryd chat",
    "clearConfirm": "Slet alle beskeder på denne enhed? Kan ikke fortrydes.",
    "clear": "Ryd chat",
    "optionSelected": "Valgt: {{label}}",
    "sendingSelection": "Sender...",
    "connectionLost": "Genforbinder..."
  },
  "reminders": {
    "title": "Mine Påmindelser",
    "active": "Aktive",
    "today": "I dag",
    "thisWeek": "Denne uge",
    "history": "Historik",
    "items": "elementer",
    "emptyTitle": "Ingen påmindelser endnu",
    "emptySubtitle": "Opret en i chatten, så vises den her.",
    "emptyAction": "Åbn chat",
    "filterActive": "Aktive",
    "filterToday": "I dag",
    "filterWeek": "Denne uge",
    "filterHistory": "Historik",
    "emptyState": "Ingen påmindelser endnu. Begynd at chatte!",
    "swipeDone": "Færdig",
    "swipeSnooze": "Udskyd",
    "swipeDelete": "Slet",
    "search": "Søg påmindelser...",
    "upcoming": "Kommende",
    "completed": "Fuldførte",
    "overdue": "Forsinkede",
    "tomorrow": "I morgen",
    "synced": "Synkroniseret {{value}}",
    "swipeHint": "Swipe en påmindelse for flere handlinger",
    "noResults": "Ingen påmindelser matcher din søgning",
    "noResultsHint": "Prøv et andet søgeord eller ryd søgningen",
    "deleteAllFailed": "Kunne ikke slette alle påmindelser"
  },
  "calendar": {
    "title": "Kalender",
    "today": "I dag",
    "tomorrow": "I morgen",
    "completed": "færdig",
    "noEvents": "Intet planlagt",
    "noEventsSubtitle": "Vælg en dato for at se påmindelser og kalenderbegivenheder.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktiv",
    "legendRecurring": "Gentagende",
    "legendDone": "Færdig",
    "legendGoogle": "Google",
    "previousMonth": "Forrige måned",
    "nextMonth": "Næste måned",
    "previousYear": "Forrige år",
    "nextYear": "Næste år",
    "goToToday": "Gå til i dag",
    "all": "Alle",
    "active": "Aktive",
    "done": "Færdige",
    "paused": "Pause"
  },
  "settings": {
    "title": "Indstillinger",
    "profile": "Profil",
    "name": "Visningsnavn",
    "enterName": "Indtast dit navn",
    "language": "Sprog",
    "uiLanguage": "App-sprog",
    "uiLanguageHelp": "Ændrer appens UI, kalenderetiketter og layoutretning kun på denne enhed.",
    "serverLanguage": "Chatsprog",
    "serverLanguageHelp": "Ændrer sproget brugt af serverens svar og påmindelsesbeskeder for din konto.",
    "timezone": "Tidszone",
    "currentTimezone": "Aktuel tidszone",
    "timezoneHelp": "Alle påmindelsestider vises i denne tidszone.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Gem tidszone",
    "timezoneSaved": "Tidszone opdateret",
    "detect": "Registrer",
    "detectFailed": "Kunne ikke registrere tidszone",
    "autoDetect": "Auto-registrer via GPS",
    "notifications": "Notifikationer",
    "notificationsHelp": "Opfølgende påmindelser styrer gentagne alarmer efter en påmindelse er leveret. Enhedens notifikationstilladelser styres stadig i telefonens indstillinger.",
    "pushEnabled": "Push-notifikationer",
    "autoDoneOnFire": "Marker automatisk som færdig ved udløb",
    "autoDoneOnFireDesc": "Hvis slået fra, forbliver påmindelser aktive indtil du markerer dem som færdige.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Forbundet",
    "googleDisconnected": "Ikke forbundet",
    "googleConnectedHelp": "Nye påmindelser kan synkroniseres automatisk til din kalender.",
    "googleDisconnectedHelp": "Forbind Google Kalender for at holde påmindelser og begivenheder synkroniseret.",
    "googleConnectFailed": "Kunne ikke forbinde Google Kalender",
    "connected": "Forbundet",
    "disconnected": "Ikke forbundet",
    "connect": "Forbind",
    "disconnect": "Afbryd",
    "autoSync": "Auto-synkroniser nye påmindelser",
    "autosync": "Auto-synkroniser nye påmindelser",
    "subscription": "Abonnement",
    "trialUsed": "Prøveperiode: {{used}}/{{total}} brugt",
    "trialStatus": "Prøveperiode tilgængelig",
    "activeStatus": "Aktivt abonnement",
    "expiredStatus": "Abonnement udløbet",
    "unsubscribedStatus": "Ikke abonneret",
    "about": "Om",
    "version": "Version",
    "logout": "Log ud",
    "logoutTitle": "Log ud",
    "logoutConfirm": "Er du sikker på, at du vil logge ud?",
    "noName": "Intet navn angivet",
    "serverConnection": "Serverforbindelse",
    "serverUrl": "Server-URL",
    "serverEdit": "Rediger",
    "saveReconnect": "Gem og genforbind",
    "resetDefault": "Nulstil til standard",
    "invalidServerUrlTitle": "Ugyldig server-URL",
    "invalidServerUrlMessage": "Indtast en gyldig http- eller https-server-URL, f.eks. https://example.com",
    "uiLanguageChangeFailed": "Kunne ikke ændre appsprog. Prøv igen.",
    "serverLanguageChangeFailed": "Kunne ikke ændre chatsprog. Prøv igen.",
    "timezoneChangeFailed": "Kunne ikke ændre tidszone. Prøv igen.",
    "autoSyncChangeFailed": "Kunne ikke opdatere auto-synkronisering. Prøv igen.",
    "nameChangeFailed": "Kunne ikke opdatere visningsnavn. Prøv igen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Påmindelsesdetaljer",
    "editTime": "Rediger tid",
    "rename": "Omdøb",
    "snooze": "Udskyd",
    "snooze15": "Udskyd 15 minutter",
    "pause": "Pause",
    "pauseReminder": "Sæt påmindelse på pause",
    "resume": "Genoptag",
    "resumeReminder": "Genoptag påmindelse",
    "skip": "Spring næste over",
    "skipOccurrence": "Spring denne forekomst over",
    "syncGoogle": "Synkroniser til Google",
    "delete": "Slet",
    "deleteTitle": "Slet påmindelse",
    "deleteConfirm": "Denne påmindelse slettes permanent.",
    "deleteRecurringTitle": "Slet gentagende påmindelse",
    "deleteRecurringMessage": "Vil du springe denne forekomst over eller slette hele serien?",
    "deleteThisOccurrence": "Spring denne forekomst over",
    "deleteEntireSeries": "Slet hele serien",
    "done": "Færdig",
    "markDone": "Marker som færdig",
    "undo": "Gendan",
    "undoPrompt": "Skal den være aktiv igen? Gendan den nu.",
    "recurring": "Gentagende",
    "nextRun": "Næste kørsel",
    "oneTime": "Engangs",
    "pending": "Afventer",
    "sent": "Sendt",
    "paused": "Sat på pause",
    "active": "Aktiv",
    "snoozed": "Udskudt",
    "localTime": "Vises i din lokale tid",
    "recurrence": "Gentagelse",
    "created": "Oprettet",
    "tags": "Tags",
    "fireCount": "Antal gange udløst",
    "actions": "Handlinger",
    "none": "Ingen",
    "snoozeFailed": "Kunne ikke udskyde påmindelse",
    "pauseFailed": "Kunne ikke sætte påmindelse på pause",
    "resumeFailed": "Kunne ikke genoptage påmindelse",
    "skipFailed": "Kunne ikke springe påmindelse over",
    "doneFailed": "Kunne ikke markere påmindelse som færdig",
    "undoFailed": "Kunne ikke gendanne påmindelsesstatus",
    "deleteFailed": "Kunne ikke slette påmindelse",
    "rescheduleTitle": "Omlægge?",
    "rescheduleMsg": "Denne påmindelse er forsinket. Vil du omlægge den?",
    "reschedule15": "Om 15 minutter",
    "reschedule60": "Om 1 time",
    "keepOverdue": "Behold som den er"
  },
  "onboarding": {
    "slide1Title": "Velkommen til FishMemory",
    "slide1Sub": "Din personlige påmindelsesassistent — drevet af WhatsApp og lavet til din lomme.",
    "slide2Title": "Bare chat naturligt",
    "slide2Sub": "Skriv påmindelser som du tænker: \"Mind mig om at ringe til mor i morgen kl. 15\" — vi klarer resten.",
    "slide3Title": "Gå aldrig glip af noget",
    "slide3Sub": "Få rettidige notifikationer, organiser med tags, og hold styr på alt vigtigt.",
    "getStarted": "Kom i gang",
    "next": "Næste",
    "firstReminderTitle": "Opret din første påmindelse!",
    "firstReminderHint": "Prøv at skrive noget som:",
    "firstReminderExample": "Mind mig om at drikke vand i morgen kl. 9",
    "gotIt": "Forstået!",
    "notifRationaleTitle": "Hold tiden",
    "notifRationaleBody": "FishMemory har brug for notifikationer for at minde dig til tiden. Du får kun alarmer for påmindelser, du opretter.",
    "notifRationaleAllow": "Aktivér notifikationer",
    "notifRationaleLater": "Måske senere",
    "swipeHint": "Swipe til højre for hurtige handlinger →",
    "calendarDragHint": "Træk for at udvide ↕"
  }
}
